
/*
 * Licensed Materials - Property of IBM
 * IBM Business Analytics (C) Copyright IBM Corp. 2020
 * US Government Users Restricted Rights - Use, duplication or disclosure restricted by GSA ADP Schedule Contract with IBM Corp.
 */

/**
 * @class SlotActionsProviderAPI
 * @hideconstructor
 * @classdesc API class that is used to implement a slot action provider for the purpose of contributing a slot action
 */
define([], () => {
	class TopBottomActionAPI {

		/**
		 * @function TopBottomActionAPI#reset
		 * @description Resets the top/bottom operation on a given data item
		 * @param {dataSlotId} id of the dataSlot
		 * @param {itemIndex} index of the dataItem
		 */
		reset(/* dataSlotId, itemIndex */) {}

	}

	return TopBottomActionAPI;
});